import { Address } from "@redotech/account-common/address";
import { WeightUnit } from "@redotech/crdb-enums/product/weight-unit";
import { DropoffRateOption } from "@redotech/merchant-sdk/rpc/schema/get-dropoff-options";
import { PurchaseLabelError } from "@redotech/merchant-sdk/rpc/schema/purchase-label";
import { Rate } from "@redotech/redo-fulfillment-carrier-common/shipment";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";

export type AddressOption = Address | "custom";

// Mutually-exclusive ways to ship one return in a single field; setting one
// supersedes the other with no sibling-clearing bookkeeping.
export type SelectedShipping =
  | { method: "label"; label: Rate }
  | { method: "dropoff"; dropoff: DropoffRateOption };

export interface LabelWeight {
  weight: number;
  unit: WeightUnit;
}
export type AddressDropdownOption<T> = RedoListItem<T>;

export enum LabelType {
  REPLACE = "replace",
  NEW = "new",
}

export enum Page {
  CREATE_LABEL = "createLabel",
  CUSTOM_SHIP_FROM = "customShipFrom",
  CUSTOM_SHIP_TO = "customShipTo",
  CONFIRMATION = "confirmation",
  DROPOFF_LOCATIONS = "dropoffLocations",
}

export type ConfirmationPageInfo =
  | {
      success: true;
      kind: "label" | "dropoff";
      labelUrl: string;
      qrCodeUrl: string | undefined;
      trackingNumber: string | undefined;
      charge: number | undefined;
    }
  | { success: false; error: PurchaseLabelError };

export type CreateLabelTarget =
  | { type: "replace"; shipmentId: string; isAdditionalShipment?: boolean }
  | { type: "addToGroup"; shipmentGroupId: string }
  | { type: "add"; fromShipmentId?: string; isAdditionalShipment?: boolean }
  // First-class target so editing a drop-off never enters queue mode.
  | { type: "editDropoff"; shipmentGroupId: string };
